/*=============================================== Loader ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled, { keyframes } from "styled-components";
import Variables from "./Variables";
import Mixins from "./Mixins";
/*==================== Component ====================*/
var Loader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "xxl" : _b, _c = _a.color, color = _c === void 0 ? "primary" : _c, props = __rest(_a, ["size", "color"]);
    return (React.createElement(Container, __assign({ "$size": size, "$color": color }, props)));
};
export default Loader;
/*==================== Styles ====================*/
var Spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        transform: rotate(0deg)\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n"], ["\n    0% {\n        transform: rotate(0deg)\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n"])));
var Container = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    border: ", "px\n        solid transparent;\n    border-bottom-color: ", ";\n    animation: ", " 1500ms linear infinite;\n"], ["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    border: ", "px\n        solid transparent;\n    border-bottom-color: ", ";\n    animation: ", " 1500ms linear infinite;\n"])), function (_a) {
    var $size = _a.$size;
    return $size === "xxl"
        ? 64
        : $size === "xl"
            ? 56
            : $size === "l"
                ? 48
                : $size === "m"
                    ? 40
                    : $size === "s"
                        ? 32
                        : $size === "xs"
                            ? 24
                            : 16;
}, function (_a) {
    var $size = _a.$size;
    return $size === "xxl"
        ? 64
        : $size === "xl"
            ? 56
            : $size === "l"
                ? 48
                : $size === "m"
                    ? 40
                    : $size === "s"
                        ? 32
                        : $size === "xs"
                            ? 24
                            : 16;
}, Variables.Radiuses.Circle, function (_a) {
    var $size = _a.$size;
    return $size === "xxl"
        ? 8
        : $size === "xl"
            ? 7
            : $size === "l"
                ? 6
                : $size === "m"
                    ? 5
                    : $size === "s"
                        ? 4
                        : $size === "xs"
                            ? 3
                            : 2;
}, Mixins.ColorsShort, Spin);
var templateObject_1, templateObject_2;
